import type { AnalyticsResponse, DashboardResponse, DepartmentRow, HoursReport, ExportFormat, VarianceFilters, VarianceReport, WorkloadRow } from '../types';
import type { PortfolioResponse } from '@/features/projects/types';
import { http } from '@/shared/api/httpClient';

const varianceParams = (f: VarianceFilters) => ({
  sprintId: f.sprintId,
  assigneeId: f.assigneeId,
  tag: f.tag,
  onlyLogged: f.onlyLogged || undefined,
  onlyVariance: f.onlyVariance || undefined
});

export const insightsApi = {
  hoursReport: (userId: string, from: string, to: string) => http.get<HoursReport>('/insights/reports/hours', { params: { userId, from, to } }).then((r) => r.data),
  departments: (days = 30) => http.get<DepartmentRow[]>('/insights/departments', { params: { days } }).then((r) => r.data),
  dashboard: (sprintId?: string) => http.get<DashboardResponse>('/insights/dashboard', { params: { sprintId } }).then((r) => r.data),
  teamWorkload: () => http.get<WorkloadRow[]>('/insights/team-workload').then((r) => r.data),
  portfolio: () => http.get<PortfolioResponse>('/insights/portfolio').then((r) => r.data),
  variance: (f: VarianceFilters) => http.get<VarianceReport>('/insights/reports/time-variance', { params: { ...varianceParams(f), size: 200 } }).then((r) => r.data),
  exportVariance: (f: VarianceFilters, format: ExportFormat) =>
    http.get<Blob>('/insights/reports/time-variance/export', { params: { ...varianceParams(f), format }, responseType: 'blob' }).then((r) => ({
      blob: r.data,
      filename: filenameFrom(r.headers['content-disposition'] as string | undefined) ?? `syncra-time-variance.${format}`
    })),
  analytics: (weeks = 8) => http.get<AnalyticsResponse>('/insights/analytics', { params: { weeks } }).then((r) => r.data)
};

function filenameFrom(disposition: string | undefined): string | null {
  const m = /filename="?([^";]+)"?/.exec(disposition ?? '');
  return m ? m[1] ?? null : null;
}
